import { createReducer } from '@reduxjs/toolkit';
import { websocketActions } from '../actions/websocket';
// Init state for the Websockets.
const initialState = {
    meta: {
        asyncRequestStatus: 'uninitialized',
        asyncCreateStatus: 'uninitialized',
        isPrimaryConnection: true,
    },
    connectionId: null,
    errors: [],
};
// Websocket reducer
export const websocketReducer = createReducer(initialState, (builder) => {
    builder.addCase(websocketActions.errorReceived, (state, action) => {
        state.errors.unshift(action.payload);
    });
    builder
        .addCase(websocketActions.request, (state) => {
        state.meta.asyncRequestStatus = 'pending';
    })
        .addCase(websocketActions.requestFulfilled, (state) => {
        state.meta.asyncRequestStatus = 'fulfilled';
    })
        .addCase(websocketActions.requestRejected, (state) => {
        state.meta.asyncRequestStatus = 'rejected';
    });
    builder
        .addCase(websocketActions.create, (state) => {
        state.meta.asyncCreateStatus = 'pending';
    })
        .addCase(websocketActions.createFulfilled, (state, action) => {
        state.meta.asyncCreateStatus = 'fulfilled';
        state.connectionId = action.payload.params.connection_id;
    })
        .addCase(websocketActions.createRejected, (state) => {
        state.meta.asyncCreateStatus = 'rejected';
        state.connectionId = null;
    });
    builder.addCase(websocketActions.connectionPrimary, (state, action) => {
        state.meta.isPrimaryConnection = !!action.payload;
    });
});
